import React from "react";
import CourseDetailTemplate from "./CourseDetailTemplate";
const CURRICULUM = [
  "Cloud Computing Fundamentals",
  "Cloud Service Models (IaaS, PaaS, SaaS)",
  "Networking and Security in Cloud",
  "Deployment and Management",
  "Cost Management Strategies",
  "Hands-on with Cloud Platforms",
  "Real-world Projects and Case Studies",
];
const STRUCTURE = [
  { title: "Admission",                      desc: "Eligibility check and onboarding process." },
  { title: "Training / Learning — 3 Months", desc: "Intensive cloud training with expert mentors." },
  { title: "Certification Preparation",      desc: "Exam prep for cloud certification." },
  { title: "Live Projects & Case Studies",   desc: "Deploy and manage real cloud solutions." },
  { title: "Monthly Assessment & Feedback",  desc: "Track progress with regular evaluations." },
  { title: "Certification & Job Support",    desc: "Industry-recognised certification on completion." },
];
const CloudTechnology = () => (
  <CourseDetailTemplate title="Cloud Technology Certification Course"
    description="Become a certified Cloud Technology expert and enhance your cloud skills! Learn cloud computing, architecture, and deployment strategies. Boost your career with hands-on projects and industry-relevant knowledge."
    curriculum={CURRICULUM} structure={STRUCTURE}
    tags={["Cloud Computing", "Azure", "AWS", "GCP", "DevOps"]}
    programName="Cloud Technology Certification Course"
  />
);
export default CloudTechnology;
